import { Component, OnInit } from "@angular/core";
import { OidcService } from "../services/oidc.service";

@Component({
    selector: 'app-callback',
    templateUrl: "./callback.component.html",
    styleUrls: ["./callback.component.scss"],
})
export class CallbackComponent implements OnInit {
    
    constructor(readonly oidcService: OidcService) { }

    ngOnInit() {
        this.oidcService.handleCallback();
    }
}